import $ from 'jquery';
window.$ = window.jQuery = $;

import 'jquery-validation';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import "./r_app";

